// The organization service's specimen endpoints, for the specimen panel.

/** A page of the specimens matching a report filter body, newest first. */
export const listSpecimens = (send, filter, page = 0, pageSize = 50) =>
  send("post")({ url: "/organization/reports/specimens", data: { filter, page, pageSize } }).then((res) => res.data);

/** One specimen with its tray, results and image links. */
export const getSpecimen = (send, trayId, specimenId, timezone) =>
  send("get")({
    url: `/organization/specimens/${encodeURIComponent(trayId)}/${encodeURIComponent(specimenId)}`,
    params: timezone ? { timezone } : undefined,
  }).then((res) => res.data);

/** Record a contributed identification; the specimen as it now reports. */
export const saveContributed = (send, trayId, specimenId, patch) =>
  send("patch")({
    url: `/organization/specimens/${encodeURIComponent(trayId)}/${encodeURIComponent(specimenId)}/contributed`,
    data: patch,
  }).then((res) => res.data);
